import { styled as muiStyled } from '@mui/material'

export const TimerStartOverlayTimerDetailsContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    gap: 30px;
    max-width: 500px;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    margin-top: 24px
`,
)

export const TimerStartOverlayTimerDetailItem = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  align-items: center;
  gap: 4px;
    .item-name {
        font-weight: 400;
        font-size: 18px;
        margin: 0;
    }
    .item-value {
        font-weight: 400;
        font-size: 18px;
        margin: 0;
    }
    .timer-div { 
        font-family: Roboto "monospace";
        margin: 0;
    }
`,
)
